import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e3c3c9ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "careersheet_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "careersheet_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "careersheet_title_text" }, "資格の編集")
], -1))
const _hoisted_3 = { class: "careersheet_input" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "運転免許")
], -1))
const _hoisted_5 = { class: "careersheet_input_layout_column_2" }
const _hoisted_6 = { class: "careersheet_input_layout_column_2_item" }
const _hoisted_7 = { class: "careersheet_input_layout_column_2_item" }
const _hoisted_8 = { class: "careersheet_input" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "資格と取得年月")
], -1))
const _hoisted_10 = { class: "careersheet_input_layout_column_1" }
const _hoisted_11 = { class: "careersheet_input_layout_column_1_item" }
const _hoisted_12 = { class: "careersheet_license_delete" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "careersheet_license_add" }
const _hoisted_15 = { class: "careersheet_button" }
const _hoisted_16 = { class: "careersheet_button_prev" }
const _hoisted_17 = { class: "careersheet_button_next" }

import { computed } from 'vue';
import { useField, useForm, useFieldArray } from 'vee-validate';
import { object, string, array } from 'yup';
import BaseButton from '@/components/BaseButton.vue';
import BaseRadioButton from '@/components/BaseRadioButton.vue';
import BaseTextForm from '@/components/BaseTextForm.vue';
import BaseYmForm from '@/components/BaseYmForm.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import { validationRuleHelper } from '@/utils/validationRule';
import VALIDATON_ERRORS from '@/constants/validationErrors';
import { Qualification, Qualifications } from '@/types';
import { useRouter, useRoute } from 'vue-router';
import store from '@/store';
import alertOnReload from '@/utils/alertOnReload';

export default /*#__PURE__*/_defineComponent({
  __name: 'SkillLicenseEditView',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const schema = object({
  qualifications: array()
    .of(
      object().shape({
        qualdetails: string().label('資格名').required(VALIDATON_ERRORS.REQUIRED).max(100),
        qualym: string().label('取得年月').required(VALIDATON_ERRORS.REQUIRED),
      })
    )
    .strict(),
});

const { errors } = useForm({
  validationSchema: schema,
});

const qualificationsErrors = (index: number, formName: string) => {
  const error = errors.value[`qualifications[${index}].${formName}`];
  return error !== undefined ? [error] : [];
};

const qualymErrors = (qualym: string) => {
  const error = /^\d{4}-\d{2}/.test(qualym) ? [] : ['取得年月は必須です'];
  return error;
};

const { value: drLicenseFlg, errors: drLicenseFlgErrors } = useField<boolean>(
  'drLicenseFlg',
  validationRuleHelper({ requiredBoolean: true }),
  {
    initialValue: store.getters['careerSheetSkillLicense/drLicenseFlg'],
    bails: false,
    label: '運転免許',
  }
);

const {
  remove: qualificationsRemove,
  replace: qualificationsReplace,
  push: qualificationsPush,
  fields: qualifications,
} = useFieldArray<Qualification & { qualificationId: number; qualymTouched: boolean }>('qualifications');

let qualificationId = 0;

const init = () => {
  const qualifications: Qualifications = store.getters['careerSheetSkillLicense/qualifications'];
  const initQualifications = qualifications.map((i) => {
    qualificationId++;
    return {
      ...i,
      qualificationId,
      qualymTouched: false,
    };
  });
  qualificationsReplace(initQualifications);
};
init();

const deleteQualification = (index: number) => {
  if (qualifications.value.length < 1) {
    return;
  }
  if (index > -1) {
    delete errors.value[`qualifications[${index}].qualdetails`];
    delete errors.value[`qualifications[${index}].qualym`];
    qualificationsRemove(index);
  }
};

const defaultQualification = {
  qualdetails: '',
  qualym: '',
  qualymTouched: false,
};

const addQualification = () => {
  qualificationId++;
  qualificationsPush({ ...defaultQualification, qualificationId });
};

const isError = computed(() => {
  if (qualifications.value.length === 0) return false;
  return qualifications.value.some((i) => {
    return !i.value.qualdetails || !/^\d{4}-\d{2}/.test(i.value.qualym);
  });
});

const transitionPreviousPage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e50', query: { ref: 'e' } });
  } else {
    router.push({ name: 'n50' });
  }
};

const transitionConfirmPage = () => {
  const param = {
    drLicenseFlg: drLicenseFlg.value,
    qualifications: qualifications.value.map((i) => {
      return {
        qualdetails: i.value.qualdetails,
        qualym: i.value.qualym,
      };
    }),
  };
  store.commit('careerSheetSkillLicense/set', param);
  if (route.query.ref === 'e') {
    router.push({ name: 'e54', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e54' });
  }
};

alertOnReload();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(BaseRadioButton, {
            label: "あり",
            name: "driving_license_os",
            value: true,
            modelValue: _unref(drLicenseFlg),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(drLicenseFlg) ? (drLicenseFlg).value = $event : null))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(BaseRadioButton, {
            label: "なし",
            name: "driving_license_os",
            value: false,
            modelValue: _unref(drLicenseFlg),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(drLicenseFlg) ? (drLicenseFlg).value = $event : null))
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createVNode(ErrorMessage, { errors: _unref(drLicenseFlgErrors) }, null, 8, ["errors"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(qualifications), (item, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: item.value.qualificationId
      }, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(BaseTextForm, {
                maxlength: 100,
                isError: qualificationsErrors(index, 'qualdetails').length > 0,
                placeholder: "資格を入力",
                modelValue: item.value.qualdetails,
                "onUpdate:modelValue": ($event: any) => ((item.value.qualdetails) = $event)
              }, null, 8, ["isError", "modelValue", "onUpdate:modelValue"])
            ])
          ]),
          _createVNode(ErrorMessage, {
            errors: qualificationsErrors(index, 'qualdetails')
          }, null, 8, ["errors"]),
          _createVNode(BaseYmForm, {
            minYm: "1960-01",
            modelValue: item.value.qualym,
            "onUpdate:modelValue": ($event: any) => ((item.value.qualym) = $event),
            suffixMonthText: "月取得",
            yearSort: "desc",
            onFocusout: () => (item.value.qualymTouched = true)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocusout"]),
          (item.value.qualymTouched)
            ? (_openBlock(), _createBlock(ErrorMessage, {
                key: 0,
                errors: qualymErrors(item.value.qualym)
              }, null, 8, ["errors"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            class: "button_license_delete",
            onClick: ($event: any) => (deleteQualification(index))
          }, "資格を削除", 8, _hoisted_13)
        ])
      ], 64))
    }), 128)),
    _createElementVNode("div", _hoisted_14, [
      (_unref(qualifications).length < 6)
        ? (_openBlock(), _createBlock(BaseButton, {
            key: 0,
            theme: "secondary",
            type: "button",
            onClick: addQualification
          }, {
            default: _withCtx(() => [
              _createTextVNode(" ＋資格を追加する（6つまで） ")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createVNode(BaseButton, {
          theme: "tertiary",
          type: "button",
          onClick: transitionPreviousPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("戻る")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(BaseButton, {
          theme: "primary",
          type: "button",
          disabled: _unref(isError),
          onClick: transitionConfirmPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("確認する")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ])
  ]))
}
}

})